<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_FICHA_CENTRAL_CLIENTE')">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_FICHA_CENTRAL_CLIENTE')">
            <form>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div
                        class="p-fluid p-formgrid grid pt-3 px-3"
                        *ngIf="cliente && !exibirSpinnerPrincipal"
                    >
                        <div class="col-12 card-detalhe-cliente mb-4">
                            <div class="formgroup">
                                <div class="p-fluid p-formgrid grid">
                                    <div class="field col-12 md:col-12 margem-field">
                                        <label class="label-sem-borda-bottom mb-2">
                                            <p>
                                                <i class="pi pi-user mr-1"></i>
                                                {{ cliente.nome + " - " + cliente.apelido }}
                                            </p>
                                        </label>

                                        <label class="form-control-sem-borda">
                                            <p>
                                                <i class="pi pi-envelope mr-1"></i>
                                                {{
                                                    cliente.email
                                                        ? cliente.email
                                                        : "E-mail não cadastrado"
                                                }}
                                            </p>
                                        </label>
                                        <label class="form-control-sem-borda">
                                            <p *ngFor="let item of contatosClientes">
                                                <i class="pi pi-phone mr-1"></i>
                                                {{ item.numero }}
                                            </p>
                                            <p *ngIf="contatosClientes.length < 1">
                                                <i class="pi pi-phone mr-1"></i>
                                                Nenhum contato cadastrado
                                            </p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w-full">
                            <p-accordion>
                                <p-accordionTab class="line-height-3 m-0">
                                    <ng-template pTemplate="header">
                                        <span class="flex align-items-center gap-2 w-full">
                                            <span class="font-bold white-space-nowrap">
                                                Avaliação (Anamnese)
                                            </span>
                                            <p-badge
                                                [value]="
                                                    listaFichaDiagnosticoCliente.length.toString()
                                                "
                                                class="ml-auto mr-2"
                                            ></p-badge>
                                        </span>
                                    </ng-template>
                                    <div class="w-full">
                                        <div class="grid p-fluid justify-content-between">
                                            <div class="col-12 md:col-1">
                                                <button
                                                    pButton
                                                    class="p-button-primary"
                                                    icon="pi pi-plus"
                                                    pTooltip="Nova avaliação"
                                                    (click)="abrirDialogAvaliacao()"
                                                ></button>
                                            </div>
                                            <div class="col-12 md:col-4">
                                                <div class="flex justify-content-end">
                                                    <div class="p-inputgroup">
                                                        <span class="p-input-icon-left">
                                                            <i class="pi pi-search"></i>
                                                            <input
                                                                pInputText
                                                                type="text"
                                                                placeholder="Buscar"
                                                                name="inputBuscaAnamnese"
                                                                class="w-full"
                                                            />
                                                        </span>
                                                        <button
                                                            type="button"
                                                            pButton
                                                            pRipple
                                                            icon="pi pi-filter-slash"
                                                            pTooltip="Limpar Filtros"
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="w-full mb-3"
                                        *ngFor="let item of listaFichaDiagnosticoCliente"
                                    >
                                        <p-card>
                                            <div
                                                class="flex justify-content-start flex-column sm:flex-row"
                                            >
                                                <div class="pt-2">
                                                    <span
                                                        *ngIf="!item.anamnese?.lgpd"
                                                        class="product-badge bg-green-600 admihair-text-white"
                                                    >
                                                        {{ item.anamnese?.descricao }}
                                                    </span>
                                                    <span
                                                        *ngIf="item.anamnese?.lgpd"
                                                        class="product-badge bg-green-600 admihair-text-white"
                                                    >
                                                        {{
                                                            verificarTextoLgpd(
                                                                item.anamnese?.descricao
                                                            )
                                                        }}
                                                    </span>
                                                    <p-badge
                                                        value="+"
                                                        class="ml-3 cursor-pointer"
                                                        (click)="
                                                            abrirDialogAvaliacaoComAnamnese(
                                                                item.anamnese
                                                            )
                                                        "
                                                    ></p-badge>
                                                </div>
                                            </div>
                                            <div
                                                *ngFor="let subItem of item.diagnosticos"
                                                class="card-simple mt-3"
                                            >
                                                <p>
                                                    <i class="pi pi-calendar mr-1"></i>
                                                    <label>
                                                        {{
                                                            subItem.data | date: "dd/MM/yyy" + ": "
                                                        }}
                                                    </label>
                                                    <label *ngIf="!subItem.lgpd">
                                                        {{ subItem.especificacao }}
                                                    </label>
                                                    <label *ngIf="subItem.lgpd">
                                                        {{
                                                            verificarTextoLgpd(
                                                                subItem.especificacao
                                                            )
                                                        }}
                                                    </label>
                                                </p>

                                                <div
                                                    class="flex justify-content-between flex-column sm:flex-row"
                                                >
                                                    <p>
                                                        <label *ngIf="subItem.observacao">
                                                            <i class="pi pi-book mr-1"></i>
                                                            <label>Observação:</label>
                                                            <label>{{ subItem.observacao }}</label>
                                                        </label>
                                                    </p>
                                                    <div>
                                                        <button
                                                            pButton
                                                            class="w-3-rem sm:w-3rem h-3rem mr-2 p-button-danger"
                                                            icon="pi pi-trash"
                                                            pTooltip="Excluir"
                                                            (click)="excluirAvaliacao(subItem.id)"
                                                        ></button>
                                                        <button
                                                            pButton
                                                            class="w-3-rem sm:w-3rem h-3rem p-button-success"
                                                            icon="pi pi-pencil"
                                                            pTooltip="Editar"
                                                            (click)="editarAvaliacao(subItem)"
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </p-card>
                                    </div>
                                </p-accordionTab>
                                <p-accordionTab class="line-height-3 m-0">
                                    <ng-template pTemplate="header">
                                        <span class="flex align-items-center gap-2 w-full">
                                            <span class="font-bold white-space-nowrap">
                                                Processos
                                            </span>
                                            <p-badge
                                                [value]="listaProcessosInicial.length.toString()"
                                                class="ml-auto mr-2"
                                            ></p-badge>
                                        </span>
                                    </ng-template>

                                    <div class="w-full">
                                        <div class="grid p-fluid justify-content-between">
                                            <div class="col-12 md:col-1">
                                                <button
                                                    pButton
                                                    class="p-button-primary"
                                                    icon="pi pi-plus"
                                                    pTooltip="Novo Processo"
                                                    (click)="abrirDialogProcessos()"
                                                ></button>
                                            </div>
                                            <div class="col-12 md:col-4">
                                                <div class="flex justify-content-end">
                                                    <div class="p-inputgroup">
                                                        <span class="p-input-icon-left">
                                                            <i class="pi pi-search"></i>
                                                            <input
                                                                pInputText
                                                                type="text"
                                                                placeholder="Buscar"
                                                                name="inputFiltroProcesso"
                                                                class="w-full"
                                                                (input)="filtrarProcessos()"
                                                                [(ngModel)]="buscaProcessos"
                                                            />
                                                        </span>
                                                        <button
                                                            type="button"
                                                            pButton
                                                            pRipple
                                                            icon="pi pi-filter-slash"
                                                            pTooltip="Limpar Filtros"
                                                            (click)="limparBuscaProcesso()"
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="card-simple mb-3"
                                        *ngFor="let item of listaProcessos"
                                    >
                                        <p>
                                            <label>
                                                <i class="pi pi-fw pi-slack mr-1"></i>
                                                <strong>{{ item.descricaoItem }}</strong>
                                            </label>
                                            <label>-</label>
                                            <label class="ml-2">
                                                <i class="pi pi-calendar mr-1"></i>
                                                {{ item.data | date: "dd/MM/yyyy" }}
                                            </label>
                                        </p>

                                        <div class="formgroup">
                                            <div class="p-fluid p-formgrid grid">
                                                <div class="field col-12 md:col-12 margem-field">
                                                    <label class="form-control-sem-borda">
                                                        {{ item.descricao }}
                                                    </label>
                                                </div>
                                                <div class="field col-12 md:col-3 margem-field">
                                                    <label class="form-control-sem-borda">
                                                        <i class="pi pi-calendar mr-1"></i>
                                                        <strong>Retorno:</strong>
                                                        {{ item.retornoDias + " dias" }}
                                                        <!-- <span style="font-size: 11px;">
																(<i class="pi pi-calendar mr-1" style="font-size: 11px;"></i>
																{{calcularDataRetorno(item.data, item.retornoDias) | date:'dd/MM/yyyy'}}) 
															</span> -->
                                                    </label>
                                                </div>
                                                <div class="field col-12 md:col-3 margem-field">
                                                    <label class="form-control-sem-borda">
                                                        <strong>Status:</strong>
                                                        <span
                                                            *ngIf="item.status"
                                                            class="ml-1 product-badge bg-green-600 admihair-text-white"
                                                        >
                                                            ATIVO
                                                        </span>
                                                        <span
                                                            *ngIf="!item.status"
                                                            class="ml-2 product-badge bg-red-600 admihair-text-white"
                                                        >
                                                            INATIVO
                                                        </span>
                                                    </label>
                                                </div>
                                                <div class="field col-12 md:col-6 margem-field">
                                                    <div class="flex justify-content-end">
                                                        <button
                                                            pButton
                                                            class="w-3-rem sm:w-3rem h-3rem mr-2 p-button-danger"
                                                            icon="pi pi-trash"
                                                            pTooltip="Excluir"
                                                            (click)="excluirProcesso(item.id)"
                                                        ></button>
                                                        <button
                                                            pButton
                                                            class="w-3-rem sm:w-3rem h-3rem mr-2 p-button-success"
                                                            icon="pi pi-pencil"
                                                            pTooltip="Editar"
                                                            (click)="editarProcesso(item)"
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordionTab>

                                <p-accordionTab class="line-height-3 m-0">
                                    <ng-template pTemplate="header">
                                        <span class="flex align-items-center gap-2 w-full">
                                            <span class="font-bold white-space-nowrap">
                                                Informes
                                            </span>
                                            <p-badge
                                                [value]="listaRecadosInicial.length.toString()"
                                                class="ml-auto mr-2"
                                            ></p-badge>
                                        </span>
                                    </ng-template>
                                    <div class="w-full">
                                        <div class="grid p-fluid justify-content-between">
                                            <div class="col-12 md:col-1">
                                                <button
                                                    pButton
                                                    class="p-button-primary"
                                                    icon="pi pi-plus"
                                                    pTooltip="Novo Recado"
                                                    (click)="abrirDialogRecado()"
                                                ></button>
                                            </div>
                                            <div class="col-12 md:col-4">
                                                <div class="flex justify-content-end">
                                                    <div class="p-inputgroup">
                                                        <span class="p-input-icon-left">
                                                            <i class="pi pi-search"></i>
                                                            <input
                                                                pInputText
                                                                type="text"
                                                                placeholder="Buscar"
                                                                name="inputBuscaRecado"
                                                                class="w-full"
                                                                (input)="filtrarMensagens()"
                                                                [(ngModel)]="buscaRecado"
                                                            />
                                                        </span>
                                                        <button
                                                            type="button"
                                                            pButton
                                                            pRipple
                                                            icon="pi pi-filter-slash"
                                                            pTooltip="Limpar Filtros"
                                                            (click)="limparBuscarMensagem()"
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p-messages
                                            [(value)]="mensagemInforme"
                                            [enableService]="false"
                                            [closable]="true"
                                        ></p-messages>
                                    </div>
                                    <div
                                        class="card-simple mb-3"
                                        *ngFor="let item of listaRecados; index as i"
                                    >
                                        <div class="flex justify-content-between">
                                            <p>
                                                <label class="mr-2">
                                                    <i class="pi pi-book mr-1"></i>
                                                    <strong>{{ "MENSAGEM " + item.tipo }}</strong>
                                                </label>
                                                <label class="inline-flex align-items-center gap-1">
                                                    <i class="pi pi-calendar mr-1"></i>
                                                    {{ item.data | date: "dd/MM/yyyy" }}
                                                </label>
                                            </p>
                                            <label>
                                                <span
                                                    *ngIf="item.prioridade"
                                                    class="text-1xl product-badge bg-red-600 admihair-text-white"
                                                >
                                                    PRIORIDADE
                                                </span>
                                            </label>
                                        </div>
                                        <div class="formgroup">
                                            <div class="p-fluid p-formgrid grid">
                                                <div class="field col-12 md:col-12 margem-field">
                                                    <label class="form-control-sem-borda">
                                                        {{ item.descricao }}
                                                    </label>
                                                </div>
                                                <div
                                                    *ngIf="item.observacao"
                                                    class="field col-12 md:col-12 margem-field"
                                                >
                                                    <label class="form-control-sem-borda">
                                                        {{ item.observacao }}
                                                    </label>
                                                </div>

                                                <div class="field col-12 md:col-3 margem-field">
                                                    <p-checkbox
                                                        [ngModel]="item.ciencia"
                                                        [binary]="true"
                                                        label="Tenho ciência"
                                                        name="checkboxCiencia{{ i }}"
                                                        (ngModelChange)="alterarCiencia(item)"
                                                    ></p-checkbox>
                                                </div>
                                                <div class="field col-12 md:col-3 margem-field">
                                                    <div class="flex">
                                                        <div class="field-radiobutton mr-2">
                                                            <p-radioButton
                                                                name="oculto{{ i }}"
                                                                [value]="'OCULTA'"
                                                                [(ngModel)]="item.status"
                                                                inputId="opcao1"
                                                                (onClick)="
                                                                    alterarStatus(item.id, 'OCULTA')
                                                                "
                                                            ></p-radioButton>
                                                            <label
                                                                style="
                                                                    margin-left: 2px;
                                                                    margin-right: 5px;
                                                                "
                                                            >
                                                                Oculta
                                                            </label>
                                                        </div>
                                                        <div class="field-radiobutton mr-2">
                                                            <p-radioButton
                                                                name="liberado{{ i }}"
                                                                [value]="'LIBERADA'"
                                                                [(ngModel)]="item.status"
                                                                inputId="opcao2"
                                                                (onClick)="
                                                                    alterarStatus(
                                                                        item.id,
                                                                        'LIBERADA'
                                                                    )
                                                                "
                                                            ></p-radioButton>
                                                            <label style="margin-left: 2px">
                                                                Liberada
                                                            </label>
                                                        </div>
                                                        <div class="field-radiobutton">
                                                            <p-radioButton
                                                                name="entregue{{ i }}"
                                                                [value]="'ENTREGUE'"
                                                                [(ngModel)]="item.status"
                                                                inputId="opcao3"
                                                                (onClick)="
                                                                    alterarStatus(
                                                                        item.id,
                                                                        'ENTREGUE'
                                                                    )
                                                                "
                                                            ></p-radioButton>
                                                            <label style="margin-left: 2px">
                                                                Entregue
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field col-12 md:col-6 margem-field">
                                                    <div class="flex justify-content-end">
                                                        <button
                                                            pButton
                                                            class="w-3-rem sm:w-3rem h-3rem mr-2 p-button-danger"
                                                            icon="pi pi-trash"
                                                            pTooltip="Excluir"
                                                            (click)="excluirMensagem(item.id)"
                                                        ></button>
                                                        <button
                                                            pButton
                                                            class="w-3-rem sm:w-3rem h-3rem mr-2 p-button-success"
                                                            icon="pi pi-pencil"
                                                            pTooltip="Editar"
                                                            (click)="editarMensagem(item)"
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordionTab>

                                <p-accordionTab class="line-height-3 m-0">
                                    <ng-template pTemplate="header">
                                        <span class="flex align-items-center gap-2 w-full">
                                            <span class="font-bold white-space-nowrap">
                                                Histórico
                                            </span>
                                        </span>
                                    </ng-template>

                                    <div class="w-full">
                                        <div class="grid p-fluid justify-content-end">
                                            <div class="col-12 md:col-4">
                                                <div class="flex justify-content-end">
                                                    <div class="p-inputgroup">
                                                        <span class="p-input-icon-left">
                                                            <i class="pi pi-search"></i>
                                                            <input
                                                                pInputText
                                                                type="text"
                                                                placeholder="Buscar"
                                                                name="inputFiltroHistorico"
                                                                class="w-full"
                                                                (input)="filtrarHistorico()"
                                                                [(ngModel)]="buscaHistorico"
                                                            />
                                                        </span>
                                                        <button
                                                            type="button"
                                                            pButton
                                                            pRipple
                                                            icon="pi pi-filter-slash"
                                                            pTooltip="Limpar Filtros"
                                                            (click)="limparBuscaHistorico()"
                                                        ></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="card-simple mb-3"
                                        *ngFor="let item of listaHistoricoCliente"
                                    >
                                        <p>
                                            <label>
                                                <i class="pi pi-fw pi-slack mr-1"></i>
                                                <strong>{{ item.descricaoItem }}</strong>
                                            </label>
                                            <label>-</label>
                                            <label class="ml-2">
                                                <i class="pi pi-calendar mr-1"></i>
                                                {{ item.data | date: "dd/MM/yyyy" }}
                                            </label>
                                        </p>

                                        <div class="formgroup">
                                            <div class="p-fluid p-formgrid grid">
                                                <div class="field col-12 md:col-4 margem-field">
                                                    <label class="label-sem-borda-bottom">
                                                        Quantidade
                                                    </label>
                                                    <label class="form-control-sem-borda">
                                                        <i class="pi pi-shopping-cart mr-1"></i>
                                                        {{ item.quantidade }}
                                                    </label>
                                                </div>
                                                <div class="field col-12 md:col-4 margem-field">
                                                    <label class="label-sem-borda-bottom">
                                                        Valor Cobrado
                                                    </label>
                                                    <label class="form-control-sem-borda">
                                                        <i class="pi pi-money-bill mr-1"></i>
                                                        {{
                                                            " " + item.valorCobrado
                                                                | currency: "BRL"
                                                        }}
                                                    </label>
                                                </div>
                                                <div class="field col-12 md:col-4 margem-field">
                                                    <label class="label-sem-borda-bottom">
                                                        Profissional
                                                    </label>
                                                    <label class="form-control-sem-borda">
                                                        <i class="pi pi-user mr-1"></i>
                                                        {{ item.nomeProfissional ?? "INDEFINIDO" }}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordionTab>
                            </p-accordion>
                        </div>
                    </div>
                    <div
                        class="p-fluid p-formgrid grid justify-content-end"
                        *ngIf="!exibirSpinnerPrincipal"
                    >
                        <div class="field col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem mt-5"
                                routerLink="/apps/central-cliente"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>

            <p-dialog
                [header]="!modoEditarAvaliacao ? 'Nova Avaliação' : 'Editar Avaliação'"
                [(visible)]="exibirDialogAvaliacao"
                [modal]="true"
                [style]="{ width: '50rem' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <div class="flex justify-content-center" *ngIf="loadingAnamnese">
                    <p-progressSpinner></p-progressSpinner>
                </div>
                <form #formAvaliacao="ngForm" name="formAvaliacao" *ngIf="!loadingAnamnese">
                    <div class="formgroup">
                        <div class="p-fluid p-formgrid grid" *ngIf="diagnosticoCliente">
                            <div class="field col-12 md:col-12">
                                <label htmlFor="anamnese">Anamnese</label>
                                <p-dropdown
                                    [options]="listaAnamnese"
                                    optionLabel="descricao"
                                    placeholder="Selecione"
                                    emptyFilterMessage="Nenhum registro"
                                    name="anamnese"
                                    ngModel
                                    #anamnese="ngModel"
                                    (onChange)="selecionarAnamnese()"
                                    [(ngModel)]="anamneseSelecionada"
                                ></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-12">
                                <label htmlFor="especificacao">Especificação</label>
                                <textarea
                                    name="especificacao"
                                    ngModel
                                    #especificacao="ngModel"
                                    rows="5"
                                    cols="30"
                                    pInputTextarea
                                    required
                                    [(ngModel)]="diagnosticoCliente.especificacao"
                                ></textarea>

                                <div
                                    *ngIf="
                                        especificacao.hasError('required') && especificacao.dirty
                                    "
                                >
                                    <small>Campo obrigatório</small>
                                </div>
                            </div>
                            <div class="field col-12 md:col-10">
                                <label htmlFor="observacao">Observação</label>
                                <textarea
                                    name="observacao"
                                    ngModel
                                    #observacao="ngModel"
                                    rows="5"
                                    cols="30"
                                    pInputTextarea
                                    [(ngModel)]="diagnosticoCliente.observacao"
                                ></textarea>
                            </div>
                            <div class="field col-12 md:col-2">
                                <label for="lgpd">LGPD</label>
                                <br />
                                <p-inputSwitch
                                    *ngIf="!bloquearCheckLgpd; else lgpdBloqueado"
                                    name="lgpd"
                                    [(ngModel)]="diagnosticoCliente.lgpd"
                                ></p-inputSwitch>
                                <ng-template #lgpdBloqueado>
                                    <p-inputSwitch
                                        [disabled]="true"
                                        [ngModel]="diagnosticoCliente.lgpd"
                                        name="lgpd"
                                    ></p-inputSwitch>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="w-full">
                    <p-divider></p-divider>
                </div>
                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div
                        class="field col-12 md:col-4"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                    >
                        <button
                            type="button"
                            pButton
                            [icon]="loadingAvaliacao ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                            [label]="!modoEditarAvaliacao ? 'Salvar' : 'Atualizar'"
                            class="p-button-success"
                            [disabled]="loadingAvaliacao"
                            (click)="salvarDiagnostico()"
                        ></button>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                    >
                        <button
                            type="button"
                            pButton
                            icon="pi pi-times"
                            label="Cancelar"
                            class="p-button-primary"
                            (click)="exibirDialogAvaliacao = false"
                            [disabled]="loadingAvaliacao"
                        ></button>
                    </div>
                </div>
            </p-dialog>

            <p-dialog
                [header]="!modoEditarProcesso ? 'Novo Processo' : 'Editar Processo'"
                [(visible)]="exibirDialogProcessos"
                [modal]="true"
                [style]="{ width: '50rem' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <form #formProcessos="ngForm" name="formProcessos">
                    <div class="formgroup">
                        <div class="p-fluid p-formgrid grid" *ngIf="processoClienteSelecionado">
                            <div class="field col-12 md:col-4">
                                <label htmlFor="data">Data</label>
                                <p-calendar
                                    [readonlyInput]="false"
                                    [showIcon]="true"
                                    dateFormat="dd/mm/yy"
                                    [showButtonBar]="true"
                                    name="data"
                                    ngModel
                                    [(ngModel)]="dataProcesso"
                                    #data="ngModel"
                                    [required]="true"
                                    [maxDate]="dataAtual"
                                ></p-calendar>
                            </div>
                            <div class="col-12 md:col-8 field">
                                <label for="produtoServico" class="text-900 font-semibold">
                                    Produto/Serviço
                                </label>
                                <div class="p-inputgroup">
                                    <label id="produtoServico" class="form-control-agrupado">
                                        {{ processoClienteSelecionado.descricaoItem }}
                                    </label>
                                    <button
                                        pButton
                                        pRipple
                                        (click)="abrirDialogItemProcesso()"
                                        pTooltip="Selecionar Produto ou Serviço"
                                        type="button"
                                        icon="pi pi-pencil"
                                        class="p-button-success"
                                    ></button>
                                </div>
                            </div>

                            <div class="field col-12 md:col-12">
                                <label htmlFor="descricao">Descrição</label>
                                <textarea
                                    name="descricao"
                                    ngModel
                                    #descricao="ngModel"
                                    rows="5"
                                    cols="30"
                                    pInputTextarea
                                    required
                                    [(ngModel)]="processoClienteSelecionado.descricao"
                                ></textarea>

                                <div *ngIf="descricao.hasError('required') && descricao.dirty">
                                    <small>Campo obrigatório</small>
                                </div>
                            </div>
                            <div class="field col-12 md:col-12">
                                <label htmlFor="retorno">Retorno (dias)</label>
                                <p-inputNumber
                                    name="retorno"
                                    ngModel
                                    #retorno="ngModel"
                                    [allowEmpty]="false"
                                    [min]="1"
                                    [required]="true"
                                    [(ngModel)]="processoClienteSelecionado.retornoDias"
                                ></p-inputNumber>
                            </div>
                            <div class="field col-12 md:col-2" *ngIf="modoEditarProcesso">
                                <label htmlFor="status">Status</label>
                                <br />
                                <p-inputSwitch
                                    name="status"
                                    [(ngModel)]="processoClienteSelecionado.status"
                                ></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="w-full">
                    <p-divider></p-divider>
                </div>
                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div
                        class="field col-12 md:col-4"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                    >
                        <button
                            type="button"
                            pButton
                            [icon]="loadingProcessos ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                            [label]="!modoEditarProcesso ? 'Salvar' : 'Atualizar'"
                            class="p-button-success"
                            [disabled]="loadingProcessos"
                            (click)="salvarProcesso()"
                        ></button>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                    >
                        <button
                            type="button"
                            pButton
                            icon="pi pi-times"
                            label="Cancelar"
                            class="p-button-primary"
                            (click)="exibirDialogProcessos = false"
                            [disabled]="loadingProcessos"
                        ></button>
                    </div>
                </div>
            </p-dialog>
            <p-dialog
                header="Recados"
                [(visible)]="exibirDialogRecado"
                [modal]="true"
                [style]="{ width: '50rem' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <form #formRecados="ngForm" name="formRecados">
                    <div class="formgroup">
                        <div class="p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-12">
                                <label htmlFor="tipo">Tipo</label>
                                <p-dropdown
                                    [options]="tiposMensagemCliente"
                                    placeholder="Selecione"
                                    emptyFilterMessage="Nenhum registro"
                                    name="tipo"
                                    ngModel
                                    #tipo="ngModel"
                                    [(ngModel)]="tipoMensagemSelecionada"
                                ></p-dropdown>
                            </div>

                            <div class="field col-12 md:col-12">
                                <label htmlFor="descricao">Descrição</label>
                                <textarea
                                    name="descricaoRecado"
                                    ngModel
                                    #descricaoRecado="ngModel"
                                    rows="5"
                                    cols="30"
                                    pInputTextarea
                                    [(ngModel)]="recadoCliente.descricao"
                                ></textarea>
                            </div>
                            <div class="field col-12 md:col-10">
                                <label htmlFor="observacao">Observação</label>
                                <textarea
                                    name="observacaoRecado"
                                    ngModel
                                    #observacaoRecado="ngModel"
                                    rows="5"
                                    cols="30"
                                    pInputTextarea
                                    [(ngModel)]="recadoCliente.observacao"
                                ></textarea>
                            </div>
                            <div class="field col-12 md:col-2">
                                <label for="prioridade">Prioridade</label>
                                <br />
                                <p-inputSwitch
                                    name="prioridade"
                                    [(ngModel)]="recadoCliente.prioridade"
                                ></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="w-full">
                    <p-divider></p-divider>
                </div>
                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div
                        class="field col-12 md:col-4"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                    >
                        <button
                            type="button"
                            pButton
                            [icon]="loadingRecado ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                            [label]="!modoEditarRecado ? 'Salvar' : 'Atualizar'"
                            class="p-button-success"
                            [disabled]="loadingRecado"
                            (click)="salvarRecado()"
                        ></button>
                    </div>
                    <div
                        class="field col-12 md:col-4"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                    >
                        <button
                            type="button"
                            pButton
                            icon="pi pi-times"
                            label="Cancelar"
                            class="p-button-primary"
                            (click)="exibirDialogRecado = false"
                            [disabled]="loadingRecado"
                        ></button>
                    </div>
                </div>
            </p-dialog>

            <p-dialog
                header="Escolher Item do Processo"
                [(visible)]="exibirDialogItemProcesso"
                [modal]="true"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
                [style]="{ width: '50vw' }"
            >
                <div class="card">
                    <div
                        class="flex justify-content-center"
                        *ngIf="exibirSpinnerDialogItemProcesso"
                    >
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="!exibirSpinnerDialogItemProcesso">
                        <p-table
                            #tbItensDialog
                            [value]="listaItensProcesso"
                            dataKey="id"
                            [rows]="itensDialogPaginados ? itensDialogPaginados.size : 0"
                            [loading]="loadingTableDialogItens"
                            [rowHover]="true"
                            [paginator]="true"
                            (onPage)="onPageChangeItensDialog($event)"
                            [totalRecords]="
                                itensDialogPaginados ? itensDialogPaginados.totalElements : 0
                            "
                            [lazy]="true"
                            [showCurrentPageReport]="true"
                            responsiveLayout="scroll"
                            styleClass=" p-datatable-sm"
                            *ngIf="!isExibirSpinnerPrincipal()"
                            currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
                        >
                            <ng-template pTemplate="caption">
                                <div class="flex justify-content-between flex-column sm:flex-row">
                                    <p-dropdown
                                        [options]="tiposItem"
                                        optionLabel="label"
                                        optionValue="value"
                                        emptyFilterMessage="Nenhum registro"
                                        name="situacao"
                                        ngModel
                                        #situacao="ngModel"
                                        [(ngModel)]="tipoItemSelecionado"
                                        (onChange)="carregarItensProcessoDialog()"
                                    ></p-dropdown>
                                    <div>
                                        <span class="p-input-icon-left">
                                            <i class="pi pi-search"></i>
                                            <input
                                                pInputText
                                                type="text"
                                                #filterItens
                                                (input)="buscarDialogItens($event)"
                                                placeholder="Buscar"
                                                class="w-full"
                                            />
                                        </span>
                                        <span class="ml-2">
                                            <button
                                                pButton
                                                class="p-button-outlined"
                                                icon="pi pi-filter-slash"
                                                pTooltip="Limpar Filtros"
                                                (click)="limparDialogItens()"
                                            ></button>
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pSortableColumn="codigo">
                                        <div>Código</div>
                                    </th>
                                    <th pSortableColumn="descricao">
                                        <div>Descrição</div>
                                    </th>
                                    <!-- <th style="text-align: center;">
										<div>
											Detalhar
										</div>
									</th> -->

                                    <th style="text-align: center">
                                        <div>Adicionar</div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-i="rowIndex">
                                <tr>
                                    <td>
                                        <label>{{ item.codigo }}</label>
                                    </td>
                                    <td>
                                        <label>{{ item.descricao }}</label>
                                    </td>
                                    <!-- <td style="text-align: center;">
										<button pButton pRipple type="button" icon="pi pi-fw pi-book"
											class="p-button-info mr-1" (click)="openItemResumo(item)">
										</button>
									</td> -->
                                    <td style="text-align: center">
                                        <button
                                            pButton
                                            pRipple
                                            type="button"
                                            icon="pi pi-check"
                                            class="p-button-success"
                                            (click)="selecionarItemDialog(item)"
                                        ></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="7">Nenhum registro encontrado.</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="loadingbody">
                                <tr>
                                    <td colspan="7">Carregando Itens. Por favor aguarde.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
                <p-footer>
                    <div class="flex justify-content-end">
                        <button
                            pButton
                            icon="pi pi-times"
                            label="Cancelar"
                            class="p-button-danger"
                            (click)="exibirDialogItemProcesso = false"
                        ></button>
                    </div>
                </p-footer>
            </p-dialog>

            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
        </div>
    </div>
</div>
